import request from "@/utils/request";
const api = {
    getUserInfo: '/api/shop/platform/user/personal/detail',//获取个人信息
    updatePassword: '/api/manage/personal/changePassword',//修改个人密码
    updateUserInfo: '/api/shop/platform/user/personal/change/password',//修改个人密码
}

export function getUserInfo(parameter){
    return request({url: api.getUserInfo, method: 'post', data: parameter})
}
export function updatePassword(parameter){
    return request({url: api.updatePassword, method: 'post', data: parameter})
}

export function updateUserInfo(parameter){
    return request({url: api.updateUserInfo, method: 'post', data: parameter})
}


